import { useQuery } from "react-query";
import getLinkedFhirResources from "./getLinkedFhirResources";
var useGetLinkedFhirResources = function useGetLinkedFhirResources(workspaceId, patientId, appointmentIds, encounterIds) {
  var _appointments$data, _encounters$data;
  var enabled = !!workspaceId && !!patientId;
  var appointments = useQuery(["linked-fhir-appointments", workspaceId, patientId, appointmentIds], function () {
    return getLinkedFhirResources(workspaceId, Number(patientId), "appointments", appointmentIds);
  }, {
    enabled: enabled && appointmentIds.length > 0
  });
  var encounters = useQuery(["linked-fhir-encounters", workspaceId, patientId, encounterIds], function () {
    return getLinkedFhirResources(workspaceId, Number(patientId), "encounters", encounterIds);
  }, {
    enabled: enabled && encounterIds.length > 0
  });
  return {
    appointmentsList: (_appointments$data = appointments.data) !== null && _appointments$data !== void 0 ? _appointments$data : [],
    encountersList: (_encounters$data = encounters.data) !== null && _encounters$data !== void 0 ? _encounters$data : [],
    isLoading: appointments.isLoading || encounters.isLoading
  };
};
export default useGetLinkedFhirResources;